// extracted by mini-css-extract-plugin
export default {"btn":"Common_btn__Cx1Nm","is-hidden":"Common_is-hidden__ZDdRh"};